import { useLayoutEffect } from 'react';
import { useLoginWidget } from '../../';

export const loginWidgetContainerId = 'runway-login-widget';

interface LoginViewProps {
  statusMessage?: JSX.Element;
}

export function LoginView({ statusMessage }: LoginViewProps) {
  const showLoginWidget = useLoginWidget();

  useLayoutEffect(() => {
    if (showLoginWidget) {
      showLoginWidget();
    }
  }, [showLoginWidget]);

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .auth0-lock.auth0-lock .auth0-lock-header-bg {
              background: transparent;
            }
            .auth0-lock.auth0-lock.auth0-lock-opened-in-frame .auth0-lock-header-bg .auth0-lock-header-bg-blur {
              opacity: 0;
              transition: none;
            }
          `,
        }}
      />
      <div
        style={{
          background:
            'url(https://bymason.com/wp-content/uploads/2020/07/device_mgmt_hero-1.png) no-repeat center center fixed',
          backgroundSize: 'cover',
          backgroundColor: '#262626',
          position: 'absolute',
          height: '100%',
          width: '100%',
        }}
      >
        <div id={loginWidgetContainerId} style={{ marginTop: 32 }} />
        <div style={{ textAlign: 'center', flexDirection: 'column', display: 'flex' }}>
          <span style={{
            color:'white',
            opacity: 0.9,
          }}>Don&apos;t have an account?</span>
          <button
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#FFFFFF',
              fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
              fontSize: 14,
              fontWeight: 500,
              height: 32,
              cursor: 'pointer',
              textAlign: 'center',
            }}
            onClick={() => {
              window.location.href = `https://bymason.com/request-a-demo/`;
            }}
          >
            Schedule a demo
          </button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>{statusMessage}</div>
      </div>
    </>
  );
}
